<span i18n>Formula: </span>
<input class="form-control" type="text" disabled [ngModel]="column.formula" />
